import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderAssociations(id: string) {
  return useQuery({
    queryKey: queryKeys.welder.associations(id),
    queryFn: () => api.getWelderAssociations(id),
  });
}
